module.exports = __webpack_public_path__ + "static/whatsapp-logo-d7481027f4ab8d7c242e73e96a14626d.png";